// brickellmensproducts.de - skin-test-dev.js - 2020.06.30

$(document).ready(function(){

  var face_look = 0;
  var improve = 0;
  var tried = 'yes';
  var current_question = 0;
  var chosen;
  var score = 60;
  var fname = "";
  var answers;
  var selected = false;

  KlaviyoSubscribe.attachToForms('.email form', {
    hide_form_on_success: true,
    extra_properties: {            
      $source: 'Quiz',
      SiteOrigin: 'DE',
      $consent: 'email'
    } 
  });

  var questions = [
    {
      // question: "What is your age?",
      question: "Wie alt sind Sie?", 
      options: [
        {
          option: "16 – 25",
          value: 0
        },
        {
          option: "26 – 35",
          value: -2
        },
        {
          option: "35 – 45",
          value: -5
        },
        {
          option: "45 – 60",
          value: -8
        },
        {
          option: "60+",
          value: -10
        },
      ]
        },
        {
        // question: "What does a typical meal look like?",
        question: "Wie sieht bei Ihnen eine typische Mahlzeit aus?",
        options: [
        {
        // option: "Chicken and salad",
        option: "Hühnchen und Salat",
        value: 5
        },
        {
        // option: "Burgers and fries",
        option: "Burger und Pommes",
        value: -5
        },
        {
        // option: "Frozen food",
        option: "Tiefkühlkost",
        value: 0
        },
        {
        // option: "Beer and take out",
        option: "Bier und Essen zum Mitnehmen",
        value: -5
        },
      ]
    },
    {
      // question: "How many hours of sleep do you get a night?",
      question: "Wie viele Stunden pro Nacht schlafen Sie?",
      options: [
        {
          option: "1 - 4",
          value: -5
        },
        {
          option: "5 - 6",
          value: 0
        },
        {
          option: "7+",
          value: 1
        },
      ]
        },
        {
        // question: "How many glasses of water do you drink daily?",
        question: "Wie viele Gläser Wasser trinken Sie pro Tag?",
        options: [
        {
        option: "1 - 3",
        value: -4
        },
        {
        option: "4 - 5",
        value: 1
        },
        {
        option: "6 - 7",
        value: 3
        },
        {
        option: "8+",
        value: 5
        },
      ]
    },
    {
      // question: "At the end of the day, does your face look:",
      question: "Sieht Ihr Gesicht am Ende des Tages so aus:",
      options: [
        {
          // option: "Dry or parched",
          option: "Trocken oder ausgetrocknet",
          value: 0
        },
        {
          // option: "Same as when you woke up",
          option: "Genau gleich wie nach dem Aufstehen",
          value: 0
        },
        {
          // option: "Oily or shiny",
          option: "Fettig oder glänzend",
          value: 0
        },
      ]
        },
        {
        // question: "How often do you exfoliate?",
        question: "Wie oft führen Sie ein Peeling durch?",
        options: [
        {
        // option: "Every day",
        option: "Täglich",
        value: -2
        },
        {
        // option: "Weekly",
        option: "Wöchentlich",
        value: 3
        },
        {
        // option: "A few times a month",
        option: "Mehrmals pro Monat",
        value: 0
        },
        {
        // option: "Never",
        option: "Nie",
        value: -2
        },
      ]
    },
    {
      // question: "Do you smoke?",
      question: "Rauchen Sie?",
      options: [
        {
          // option: "Yes",
          option: "Ja",
          value: -10
        },
        {
          // option: "No",
          option: "Nein",
          value: 5
        },
      ]
        },
        {
        // question: "What about your skin would you most like to improve?",
        question: "Was würden Sie an Ihrer Haut am liebsten verbessern?",
        options: [
        {
        // option: "Fine lines and wrinkles",
        option: "Feine Linien und Falten",
        value: 0
        },
        {
        option: "",
        value: 0
        },
        {
        // option: "Daily skin care",
        option: "Tägliche Hautpflege",
        value: 0
        },
        {
        // option: "Tired eyes",
        option: "Müde Augen",
        value: 0
        },
        {
        // option: "Oily skin",
        option: "Fettige Haut",
        value: 0
        },
        {
        //option: "Even skin tone",
        option: "Gleichmäßiger Hautton",
        value: 0
        },
        {
        //option: "Large pores",
        option: "Große Poren",
        value: 0
        },
        {
        option: "",
        value: 0
        }
      ]
    },
    {
      // question: "What does your current skin care routine look like?",
      question: "Wie sieht Ihre derzeitige Hautpflege-Routine aus?",
      options: [
        {
          // option: "I don't have one",
          option: "Ich habe keine",
          value: -4
        },
        {
          // option: "I use some face wash",
          option: "Ich verwende etwas Gesichtsreinigung",
          value: 0
        },
        {
          // option: "I wash my face, moisturize, and maybe use a few other products",
          option: "Ich wasche mein Gesicht, benutze Feuchtigkeitscreme und einige weitere Produkte",
          value: 5
        },
        {
          // option: "I have a full routine that includes daily skin care and anti aging",
          option: "Ich habe eine komplette Routine, die ein tägliches Hautpflege- und Anti-Aging-Programm umfasst.",
          value: 5
        },
      ]
        },
        {
        // question: "Have you tried our free sample kit?",
        question: "Haben Sie unser kostenloses Probe Set ausprobiert?",
        options: [
        {
        // option: "Yes",
        option: "Ja",
        value: 0
        },
        {
        // option: "No",
        option: "Nein",
        value: 0
        },
      ]
    },
  ];
    var articles = [
    [
    {
    title: "Skin Care Routine for Men With Dry Skin",
    link: "/blogs/grooming-manual/89761155-skin-care-routine-for-men-with-sensitive-or-dry-skin"
    },
    {
    title: "The Top 5 Anti Aging Tips for Men",
    link: "/blogs/grooming-manual/66267203-top-5-anti-aging-tips-for-men"
    }
  ],
      [
        {
          title: "A Men's Skin Care Routine",
          link: "/blogs/grooming-manual/67369987-advanced-mens-skin-care-routine"
        },
        {
          title: "The Top 5 Anti Aging Tips for Men",
          link: "/blogs/grooming-manual/66267203-top-5-anti-aging-tips-for-men"
        }
      ],
      [
        {
          title: "How to Prevent Excess Oily Skin",
          link: "/blogs/grooming-manual/86457667-men-how-to-prevent-excess-oily-skin"
        },
        {
          title: "A Men's Skin Care Routine",
          link: "/blogs/grooming-manual/67369987-advanced-mens-skin-care-routine"
        }
      ],
      ];


  var customs_face = [

    [
      {
        text: 'Our <a href="/products/face-wash-for-men">Purifying Charcoal Face Wash</a> to cleanse skin while hydrating and not over drying.',
        id: 'face-wash-for-men'
      },
      {
        text: 'Our <a href="/products/mens-face-moisturizer">Daily Essential Face Moisturizer</a> hydrates your skin for all day moisture.',
        id: 'mens-face-moisturizer'
      },
      {
        text: 'Our <a href="/products/reviving-day-mens-face-serum">Reviving Day Serum</a> provides nutrients to deep down skin cells, while stimulating collagen production.',
        id: 'reviving-day-mens-face-serum'
      }
    ],
    [
      {
        text: 'Our <a href="/products/balancing-toner-for-men">Balancing Toner</a> to even out skin tone and minimize pores.',
        id: 'balancing-toner-for-men'
      },
      {
        text: 'Our <a href="/products/clarifying-gel-face-wash-for-men">Clarifying Gel Face Wash</a> to help remove impurities and leave the face feeling refreshed.',
        id: 'clarifying-gel-face-wash-for-men'
      },
      {
        text: 'Our <a href="/products/mens-face-scrub">Renewing Face Scrub</a> to remove dead skin, impurities and pore build up.',
        id: 'mens-face-scrub'
      },
      {
        text: 'Our lightweight <a href="/products/mens-face-moisturizer">Daily Essential Face Moisturizer</a> to add hydration without shine.',
        id: 'mens-face-moisturizer'
      }
    ],
    [
      {
        text: 'Our <a href="/products/clarifying-gel-face-wash-for-men">Clarifying Gel Face Wash</a> to to help remove oil and prevent shine.',
        id: 'clarifying-gel-face-wash-for-men'
      },
      {
        text: 'Our <a href="/products/mens-face-scrub">Renewing Face Scrub</a> to remove dead skin, impurities and pore build up.',
        id: 'mens-face-scrub'
      },
      {
        text: 'Our lightweight <a href="/products/mens-face-moisturizer">Daily Essential Face Moisturizer</a> to add hydration without shine.',
        id: 'mens-face-moisturizer'
      }
    ]

  ];
  // var skin_type = ["dry", "normal", "oily/combo"];
  var skin_type = ["trocken", "normale", "ölige/mischhaut"];

  var customs_improve = [
    {
      // title: "We recommend one of our serums:",
      title: "We recommend one of our serums:",
      products: [
        {
          name: "Reviving Day Serum",
          picture: "https://cdn.shopify.com/s/files/1/0513/2409/products/Reviving_grande.png",
          link: "/products/reviving-day-mens-face-serum",
          id: 484830838832
        },	
        {
          name: "Repairing Night Serum",
          picture: "https://cdn.shopify.com/s/files/1/0513/2409/products/Repairing_grande.png",
          link: "/products/repairing-night-mens-face-serum",
          id: 324986142768
        },	
        {
          name: "Daily Defense Face Moisturizer",
          picture: "https://cdn.shopify.com/s/files/1/0513/2409/products/2oz_Daily_Defense_Face_Moisturizer_855767007706.png?v=1544714993",
          link: "/products/best-mens-face-moisturizer-with-spf",
          id: 886046228528
        }
      ]
    },
    {
      // title: "We recommend our serums and anti aging cream:",
      title: "We recommend our serums and anti aging cream:",
      products: [
        {
          name: "Reviving Day Serum",
          picture: "https://cdn.shopify.com/s/files/1/0513/2409/products/Reviving_grande.png",
          link: "/products/reviving-day-mens-face-serum",
          id: 484830838832
        },	
        {
          name: "Repairing Night Serum",
          picture: "https://cdn.shopify.com/s/files/1/0513/2409/products/Repairing_grande.png",
          link: "/products/repairing-night-mens-face-serum",
          id: 324986142768
        },
        {
          name: "Revitalizing Anti-Aging Cream",
          picture: "https://cdn.shopify.com/s/files/1/0513/2409/products/AntiAgingCream_2048_Rev1_grande.png",
          link: "/products/anti-aging-cream-for-men",
          id: 484827693104
        },	
      ]
        },
        {
        // title: "We recommend our Daily Advanced Skin Care Routine:",
        title: "We recommend our Daily Advanced Skin Care Routine:",
        products: [
        {
        name: "Men's Daily Advanced Face Care Routine",
        picture: "https://cdn.shopify.com/s/files/1/0513/2409/products/mens_skincare_set_1024x1024_49b908f9-a78b-4382-bbb7-d0e152706ca2_grande.png",
        link: "/products/mens-daily-advanced-face-care-routine-i",
        id: 484829823024
        },	
        {
        name: "Daily Defense Face Moisturizer",
        picture: "https://cdn.shopify.com/s/files/1/0513/2409/products/2oz_Daily_Defense_Face_Moisturizer_855767007706.png?v=1544714993",
        link: "/products/best-mens-face-moisturizer-with-spf",
        id: 886046228528
        }
      ]
    },            
    {
      // title: "We recommend our Restoring Eye Balm:",
      title: "We recommend our Restoring Eye Balm:",
      products: [
        {
          name: "Restoring Eye Cream",
          picture: "https://cdn.shopify.com/s/files/1/0513/2409/products/Brickell_Restoring_Eye_Balm_.5oz.png",
          link: "/products/best-eye-cream-for-men",
          id: 484828676144
        },		
      ]
    },  
    {
      // title: "We recommend our Clarifying Gel Cleanser:",
      title: "We recommend our Clarifying Gel Cleanser:",
      products: [
        {
          name: "Clarifying Gel Face Wash",
          picture: "https://cdn.shopify.com/s/files/1/0513/2409/products/best_face_wash_for_men_grande.png",
          link: "/products/clarifying-gel-face-wash-for-men",
          id: 324985421872
        },	
        {
          name: "Balancing Toner",
          picture: "https://cdn.shopify.com/s/files/1/0513/2409/products/Balancing_Toner_1.png",
          link: "/products/balancing-toner-for-men",
          id: 1398169993264
        }
      ]
    },  
    {
      // title: "We recommend our Advanced Anti Aging Routine:",
      title: "We recommend our Advanced Anti Aging Routine:",
      products: [
        {
          name: "Reviving Day Serum",
          picture: "https://cdn.shopify.com/s/files/1/0513/2409/products/Reviving_grande.png",
          link: "/products/reviving-day-mens-face-serum",
          id: 484830838832
        },	
        {
          name: "Repairing Night Serum",
          picture: "https://cdn.shopify.com/s/files/1/0513/2409/products/Repairing_grande.png",
          link: "/products/repairing-night-mens-face-serum",
          id: 324986142768
        },
        {
          name: "Advanced Anti Aging Routine",
          picture: "https://cdn.shopify.com/s/files/1/0513/2409/products/Repairing_Group_1024x1024_7e317f6f-6605-402f-b515-d3e620df83ff_grande.png",
          link: "/products/advanced-anti-aging-routine",
          id: 484830445616
        },	
        {
          name: "Balancing Toner",
          picture: "https://cdn.shopify.com/s/files/1/0513/2409/products/Balancing_Toner_1.png?v=1544726653",
          link: "/products/balancing-toner-for-men",
          id: 1398169993264
        }
      ]
    },  
    {
      // title: "We recommend our Daily Advanced Skin Care Routine:",
      title: "We recommend our Daily Advanced Skin Care Routine:",
      products: [
        {
          name: "Men's Daily Advanced Face Care Routine",
          picture: "https://cdn.shopify.com/s/files/1/0513/2409/products/mens_skincare_set_1024x1024_49b908f9-a78b-4382-bbb7-d0e152706ca2_grande.png",
          link: "/products/mens-daily-advanced-face-care-routine-i",
          id: 484829823024
        },
        {
          name: "Balancing Toner",
          picture: "https://cdn.shopify.com/s/files/1/0513/2409/products/Balancing_Toner_1.png?v=1544726653",
          link: "/products/balancing-toner-for-men",
          id: 1398169993264
        }

      ]
    }

  ];


  if (Cookies.get("score")) {

    score = Math.floor(Cookies.get("score"));
    fname = Cookies.get("fname");
    improve = Cookies.get("improve");
    face_look = Cookies.get("face_look");
    tried = Cookies.get('tried');
    showResults();
    $(".results").show();
    $(".question, .introduction").hide();

  }

  $("#content").css("border-bottom", 0).css("padding-top", 0);
  $(".start").click(function(){
    $('.skin-test').addClass('started');
    answers = [];
    $(".test-progress h3").text("1 of 10");
    $(".back").hide();
    var question = questions[current_question];
    $(".introduction").hide();
    $(".question").not(".email").show();
    $(".question h2").text(question.question);
    loadQuestions(question);
  });

  $(".retake a").click(function(e){
    e.preventDefault();
    Cookies.remove("score");
    Cookies.remove("fname");
    Cookies.remove("improve");
    Cookies.remove("tried");
    Cookies.remove("face_look");
    score = 60;
    answers = [];
    $(".introduction").show();
    $(".results").hide();
    current_question = 0;
    $(".options").empty();
    $('section.k3, section.k2').hide();
    $(".recommended-articles .articles").empty();
  });
  $(".back").click(function(){
    $('.option.selected').removeClass('selected');
    if (face_look == 0 && current_question == 5) {
      questions[8].options = [
        {
          // option: "Fine lines and wrinkles",
          option: "Fine lines and wrinkles",
          value: 0
        },
        {
          // option: "Firmer, tighter look",
          option: "Festeres, strafferes Aussehen",
          value: 0
        },
        {
          // option: "Daily skin care",
          option: "Tägliche Hautpflege",
          value: 0
        },
        {
          // option: "Tired eyes",
          option: "Müde Augen",
          value: 0
        },
        {
          // option: "Oily skin",
          option: "Fettige Haut",
          value: 0
        },
        {
          // option: "Even skin tone",
          option: "Gleichmäßiger Hautton",
          value: 0
        },
        {
          // option: "Large pores",
          option: "Große Poren",
          value: 0
        },
      ];
        }

        current_question--;
        $(".test-progress h3").text((current_question + 1) + " of 10");
        if (current_question == 0) {
        $(".back").hide();
        }
        score -= questions[current_question].options[answers[current_question]].value;
      var question = questions[current_question];
      $(".question h2").text(question.question);
      $(".options").empty();
      loadQuestions(question);
      answers.pop();
    });
    function showResults() {
      Cookies.set("taken", 1);
      if (face_look == 0 && improve == 2) {
        customs_improve[2].products[0].name = "Men's Daily Essential Face Care Routine II";
        customs_improve[2].products[0].picture = "https://cdn.shopify.com/s/files/1/0513/2409/products/mens_facial_lotion_and_mens_face_cleanser.png?v=1489348572";
        customs_improve[2].products[0].link = "/products/mens-daily-essential-face-care-routine-charcoal";
        customs_improve[2].products[0].id = 484829397040; 
      }
      if ((face_look == 1 || face_look == 3) && improve == 2) {
        customs_improve[2].products[0].name = "Men's Daily Advanced Face Care Routine I";
        customs_improve[2].products[0].picture = "https://cdn.shopify.com/s/files/1/0513/2409/products/mens_skincare_set_1024x1024_49b908f9-a78b-4382-bbb7-d0e152706ca2_1024x1024.png?v=1489371856";
        customs_improve[2].products[0].link = "/products/mens-daily-advanced-face-care-routine-i";
        customs_improve[2].products[0].id = 484829823024; 
      }

      var result = "";
      if (score <= 20) {
        // result = "Your skin is in very bad shape. You need to change your lifestyle and upgrade your skin care routine.";
        result = "Ihre Haut ist in einem sehr schlechten Zustand. Sie müssen Ihren Lebensstil ändern und Ihre Hautpflege-Routine verbessern.";
      } else if (score >= 21 && score <= 40) {
        // result = "Your skin is not in good shape.";
        result = "Ihre Haut ist in keinem guten Zustand.";
      } else if (score >= 41 && score <= 60) {
        // result = "Your skin is in ok shape.";
        result = "Ihre Haut ist in Ordnung.";
      } else if (score >= 61 && score <= 80) {
        // result = "You have decent skin but there is room for improvement.";
        result = "Sie haben eine gepflegte Haut, aber es gibt Raum für Verbesserungen.";
      } else if (score >= 81 && score <= 90) {
        // result = "Your skin is in good shape but there is room for improvement.";
        result = "Ihre Haut ist in einem guten Zustand, aber es gibt Raum für Verbesserungen.";
      } else if (score > 90) {
        // result = "Your skin is in excellent shape.";
        result = "Ihre Haut ist in ausgezeichneter Verfassung.";
      }
      if (tried == "1") {
        // result += ' Based on your answers, we recommend trying our <a href="/products/brickell-mens-best-sellers-sample-kit">Free Sample Kit</a>.';
        result += ' Ihre Haut ist in Ordnung. Basierend auf Ihren Antworten empfehlen wir Ihnen, unser <a href="/products/brickell-mens-best-sellers-sample-kit">kostenloses Probe Set</a> auszuprobieren.';
      } else {
        // result += ' See our recommendations below on how to improve.';
        result += ' Lesen Sie unsere Empfehlungen weiter unten zur Verbesserung Ihrer Haut.';
      }
      $(".recommended-articles .articles").empty();
      for (var i = 0; i < 2; i++) {
        //$(".recommended-articles .articles").append("<p><a href='" + articles[face_look][i].link + "'>" + articles[face_look][i].title + "</a></p>")

      }
      $(".results h1").text("Hey " + fname + ", Ihr Punktestand ist: " + score + " von 100");
      if (tried == "1") {  	
        //$(".results .custom-face h3").html('');
        //$(".custom-face p").html(customs_face[face_look]);
        $(".custom-face p").html(text_suggestions);
        $('section.k3, section.k2').show();
        $('.custom-face .sample-kit-container').show();
        $('.custom-face .suggested-container').hide();
        $(".custom-improve").hide();
        $(".skin-test").addClass("tried");
      } else {
        //$("#resultsp").html(customs_face[face_look]);
        $(".skin-test").removeClass("tried");
        // $(".results .custom-face > h3.title").html('Based on your answers and your ' + skin_type[face_look] + ' skin, we recommend these products:');
        $(".results .custom-face > h3.title").html('Basierend auf Ihren Antworten und Ihrer ' + skin_type[face_look] + ' Haut, empfehlen wir folgende Produkte:');
        $(".custom-face .suggested-container .product").hide();
        var text_suggestions = "";
        for (var i = 0; i < customs_face[face_look].length; i++) {
          $(".custom-face .suggested-container .product." + customs_face[face_look][i].id).show();
          text_suggestions += customs_face[face_look][i].text + "<br><br>";
        }
        //$(".custom-face p").html(text_suggestions);
        $('.custom-face .sample-kit-container').hide();
        $('.custom-face .suggested-container').show();
        if (improve == 7) {
          $(".custom-improve").hide();
        } else {
          $(".custom-improve").show();
          // $(".custom-improve h3").text("To help with your objective of " + questions[7].options[improve].option + ", we suggest learning more about the following products:");
          $(".custom-improve h3").text("To help with your objective of " + questions[7].options[improve].option + ", we suggest learning more about the following products:");
          $(".results .custom-improve .products").empty();
          for (var i = 0; i < customs_improve[improve].products.length; i++) {
            $(".results .custom-improve .products").append("<div class='product span3'><img src='" + customs_improve[improve].products[i].picture + "'><h3>" + customs_improve[improve].products[i].name + "</h3><div class='yotpo bottomLine' data-appkey='HB2ysZp6ROjiio3fXMJ9LrRGvuyn37u7yRzh3BC2' data-domain='{{ shop.permanent_domain | escape }}' data-product-id='" + customs_improve[improve].products[i].id + "' data-product-models='" + customs_improve[improve].products[i].id + "'></div><a href='" + customs_improve[improve].products[i].link + "' class='button'>Add to Cart</a></div>");
          }
        }
      }
      $(".results .score-details").html(result);


    }
    function loadQuestions(question) {
      for (var j = 0; j < question.options.length; j++) {
        if (question.options[j].option != "") {
          $(".options").append("<div class='option'><input type='radio' style='display:none;' id='" + j + '' + current_question + "' value='" + j + "' name='" + current_question + "' /><label for='" + j + '' + current_question + "'>" + question.options[j].option + "</label></div>");
        }
      }
      $("input[name='" + current_question + "']").change(function(){
        if (!selected) {
          $(this).parent().addClass('selected');	
        }
        selected = true;
        setTimeout(function(){
          console.log(current_question);

          if (!isNaN(parseInt($("input[name='" + current_question + "']:checked").val()))) {
            chosen = parseInt($("input[name='" + current_question + "']:checked").val());
            answers.push(chosen);
            $(".back").show();
            switch (current_question) {
              case 4:
                face_look = chosen;
                if (chosen == 0) {
                  questions[7].options[4].option = "";
                  questions[7].options[6].option = "";
                } else {
                  // questions[7].options[4].option = "Oily skin";
                  questions[7].options[4].option = "Fettige Haut";
                  //questions[7].options[6].option = "Large pores";
                  questions[7].options[6].option = "Große Poren";
                }
                break;
              case 7:
                improve = chosen;
                console.log(chosen);
                break;
              case 9:
                tried = chosen;
                break;
            }

            score += questions[current_question].options[chosen].value;
            //console.log(score);
            current_question++;
            $(".test-progress h3").text((current_question + 1) + " of 10");
            if (current_question == questions.length) {

              $(".question").hide();
              //         $(".results").show();
              if (Cookies.get("taken") != "1") {
                // $(".email h2").text("What is your first name and email address?");
                $(".email h2").text("Wie lautet Ihr Vorname und Ihre Email?");
                $(".email.question").show();
                $(".email.question form").submit(function(e){
                  if ($('#quiz_signup input[name=first_name]').val() == '' || $('#quiz_signup input[name=email]').val() == '') {
                    return;	
                  }
                  $(".email.question").hide();
                  $(".results").show();
                  fname = $("input[name='first_name']").val();
                  Cookies.set("fname", fname);
                  Cookies.set("tried", tried);
                  Cookies.set("score", score);
                  Cookies.set("face_look", face_look);
                  Cookies.set("improve", improve);
                  showResults();

                });
              } else {
                $(".results").show();
                fname = $("input[name='first_name']").val();
                Cookies.set("fname", fname);
                Cookies.set("tried", tried);
                Cookies.set("score", score);
                Cookies.set("face_look", face_look);
                Cookies.set("improve", improve);
                showResults();
              }



            } else {
              var question = questions[current_question];
              $(".question h2").text(question.question);
              $(".options").empty();
              loadQuestions(question);
            }
          } 
          selected = false;
        }, 500);

      });
    }
  });